export function init() {
    doGoogleMaps();
}


function doGoogleMaps() {
    jQuery.getScript("https://maps.googleapis.com/maps/api/js?key=" + base.googlemapkey + "&v=weekly&libraries=places,geometry", function () {
        jQuery(".googlemap").each(function () {
            var cb_function = jQuery(this).data("callbackfunction");

            if (cb_function == "initPostCodeSearch") {
                initPostCodeSearch();
            } else if (cb_function == "initMap") {
                initMap()
            }

            //window[cb_function]();
        })
    });
}

export function initPostCodeSearch() {
    jQuery("input.postcodesearch").each(function (el) {

        var thisadd = jQuery(this).val();
        var thisid = jQuery(this).attr("id");
        var thisel = jQuery(this);

        if (thisid) {

            const autocomplete = new google.maps.places.Autocomplete(document.getElementById(thisid), {
                fields: ["formatted_address", "geometry", "name"],
                strictBounds: false,
                componentRestrictions: { country: "au" },
                types: ["(regions)"],
                elid: thisid
            });

            google.maps.event.addListener(autocomplete, 'place_changed', function (thisel) {
                var thiselid = autocomplete.elid;
                console.log("thiselid: ", thiselid)
                var place = autocomplete.getPlace();
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();
                single.show_closest_stockist(lat, lng, thiselid);
            })

            jQuery("#wheretobuyform").on("submit", function () {
                var place = autocomplete.getPlace();
                var lat = place.geometry.location.lat();
                var lng = place.geometry.location.lng();

                return false;
            });
        }

    })


}